module.exports = __webpack_public_path__ + "static/media/promotion-banner.3d74cfab.png";